import { put, call, takeLatest } from 'redux-saga/effects'

import { getTags as getPaymentMethodsApi } from 'Service/Api'

import { PAYMENT_TYPE_PARAM } from 'Constants'
import * as PaymentMethodTypes from 'Redux/Types/PaymentMethodTypes'
import * as PaymentMethodActions from 'Redux/Actions/PaymentMethodActions'

function* getPaymentMethods() {
  try {
    const { data } = yield call(getPaymentMethodsApi, PAYMENT_TYPE_PARAM)
    yield put(PaymentMethodActions.getPaymentMethodsSucceeded(data))
  } catch (errors) {
    yield put(PaymentMethodActions.getPaymentMethodsFailed(errors))
  }
}

export default function* PaymentMethodSaga() {
  yield takeLatest(PaymentMethodTypes.GET_PAYMENT_METHODS, getPaymentMethods)
}
